import React, { ReactElement } from 'react';
import GlobalTemplate from '../global';
import LibraryMain from './partials/library-main';

// The wrapper template for all pages on the /library route
export default function LibraryTemplate({ children }): ReactElement {
  return (
    <GlobalTemplate navBgColor="bone">
      <LibraryMain>{children}</LibraryMain>
    </GlobalTemplate>
  );
}
